import type { MessageInstance } from 'antd/es/message/interface'
import type { ModalStaticFunctions } from 'antd/es/modal/confirm'
import type { NotificationInstance } from 'antd/es/notification/interface'
import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { ConfigProvider, App } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { useSnapshot } from 'valtio'
import { globalState, configAction } from '@/store/index'
import 'antd/dist/reset.css'
import '@wair/markdown/style'
import '@/assets/styles/index.less'
import router from './router'
import { PageStayTimeProvider } from '@/contexts/pageStayTimeContext'

let message: MessageInstance
let notification: NotificationInstance
let modal: Omit<ModalStaticFunctions, 'warn'>

function Rooter() {
  // 需要挂载到 antd/App 内
  const staticFunction = App.useApp()
  message = staticFunction.message
  modal = staticFunction.modal
  notification = staticFunction.notification
  return <RouterProvider router={router} />
}

export default function RootApp() {
  const { theme, userInfo } = useSnapshot(globalState)

  useEffect(() => {
    configAction.getBaseConfig()
  }, [userInfo.authCode])

  return (
    <ConfigProvider prefixCls="metahuman" locale={zhCN} theme={theme}>
      <PageStayTimeProvider>
        <App>
          <Rooter />
        </App>
      </PageStayTimeProvider>
    </ConfigProvider>
  )
}

export { message, notification, modal }
